import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import LogsService from '@/services/LogsService';
import PostCardModule from '@/store/modules/PostCardModule';
import DigitalRepliesModule from '@/store/modules/DigitalRepliesModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import AuthModule from './modules/AuthModule';
import RestrictionModule from './modules/RestrictionModule';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isElectron: false,
  },
  mutations: {
    SET_IS_ELECTRON(state, value) {
      state.isElectron = value;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    sendStat({ commit }, stat) {
      LogsService.sendLog(stat.meta, stat.description);
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth: AuthModule,
    post: PostCardModule,
    replies: DigitalRepliesModule,
    restriction: RestrictionModule,
  },
  strict: process.env.DEV,
})
